import { anchorPriceGenerationStore } from '@features/suggested-price-column/store/anchor-price-generation-store';
import {
  ShouldShowSuggestedPriceColumnParams,
  shouldShowSuggestedPricePerUnitColumn,
} from './should-show-suggested-price-per-unit-column';

// Fires STALE on the anchor-price generation store only when the Suggested Price column is
// actually visible for the current buyer + event. Wraps the full visibility gate so every
// mutation site (add / edit / paste / delete) uses the same check and cannot drift.
export const markSuggestedPricesStale = (params: ShouldShowSuggestedPriceColumnParams): void => {
  if (shouldShowSuggestedPricePerUnitColumn(params)) {
    anchorPriceGenerationStore.markStale();
  }
};
